document.currentScript.parentElement.addEventListener("click", (e) => {
  const opener = e.target.closest("modal-opener");
  if (!opener) return;

  const optionPosition = opener.dataset.optionPosition?.toLowerCase();
  const optionName = opener.dataset.optionName?.toLowerCase();

  if (!optionPosition || !optionName) return;

  const modal = document.querySelector(
    'modal-dialog[id^="ProductModal-variant_picker"]'
  );
  if (!modal) return;

  const headingEl = modal.querySelector("[data-popup-heading]");

  if (headingEl) {
    const translated = opener.dataset.headingTitle;

    if (translated) {
      headingEl.textContent = translated;
    }
  }

  const fieldsets = modal.querySelectorAll(".product-form__controls");

  fieldsets.forEach((fieldset) => {
    const indexMatch = fieldset.dataset.optionPosition === optionPosition;
    const nameMatch = fieldset.dataset.optionName === optionName;

    fieldset.style.display = indexMatch || nameMatch ? "" : "none";
  });
});
